import { render, staticRenderFns } from "./BrandOrPriceMerchantDia.vue?vue&type=template&id=12544380"
import script from "./BrandOrPriceMerchantDia.vue?vue&type=script&lang=js"
export * from "./BrandOrPriceMerchantDia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports